module.exports = __webpack_public_path__ + "media/images/tmp/slide9-366046a927f9af7d5804130eaf945c1f.jpg";